import { createContext, useCallback, useContext, useRef } from 'react';
import type { DataConnection } from '@glueapp/graph-types';
// Create a new context
const ConnectionLookupContext = createContext<(nodeInstanceId: number, portName: string, type: 'input' | 'output') => boolean>(() => false);

interface Props {
    connections: DataConnection[];
    children: React.ReactNode;
}

// Create a context provider component
export const ConnectionLookupProvider = ({ children, connections }: Props) => {
    const connectionsRef = useRef(connections);
    connectionsRef.current = connections;
    const connectionsLookup = useCallback(
        (nodeInstanceId: number, portName: string, type: 'input' | 'output') => {
            const connections = connectionsRef.current;

            switch (type) {
                case 'input':
                    return connections.some(
                        connection => connection.receivingNodeInstanceId === nodeInstanceId && connection.receivingPortName === portName,
                    );
                case 'output':
                    return connections.some(
                        connection => connection.sendingNodeInstanceId === nodeInstanceId && connection.sendingPortName === portName,
                    );
            }
        },
        [connectionsRef],
    );
    return <ConnectionLookupContext.Provider value={connectionsLookup}>{children}</ConnectionLookupContext.Provider>;
};

export function useConnectionLookup() {
    const lookupConnection = useContext(ConnectionLookupContext);

    return { lookupConnection };
}
